import React from 'react';
import { getModKeyLabel } from '../../utils/keyboard';

/**
 * Tooltip CONTENT that names an action and its keyboard shortcut:
 *   <Tooltip content={<ShortcutHint label="Send message" keys={['mod', 'Enter']} />}>
 * `mod` is Ctrl, or ⌘ on macOS. The key caps use the look of the request pane's shortcut
 * list (RequestBuilder's empty-response hints) — the app's one <kbd> style.
 */
export default function ShortcutHint({ label, keys = [] }) {
  const mod = getModKeyLabel();
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      <span>{label}</span>
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 3 }}>
        {keys.map((k) => (
          <kbd
            key={k}
            style={{
              padding: '1px 5px', borderRadius: 4, border: '1px solid rgba(255,255,255,0.22)', background: 'rgba(255,255,255,0.08)',
              fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace', fontSize: 10, fontWeight: 500, lineHeight: 1.5,
            }}
          >
            {k === 'mod' ? mod : k}
          </kbd>
        ))}
      </span>
    </span>
  );
}
